import { jsx as _jsx } from "react/jsx-runtime";
const CommonLoader = ({ className, containerClassName = "custom-loader-container", loaderClass = "custom-loader-img" }) => {
    return (_jsx("div", { className: ` ${containerClassName || ''}`, children: _jsx("div", { className: loaderClass, children: _jsx("img", { src: "/assets/custom-loader.gif", alt: "Loading...", className: className }) }) }));
};
export default CommonLoader;
